import {
  SET_GROUPS,
} from '../types';

const initialState = {
  groups: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    default:
      return state;
  }
};
